import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 875.000000 875.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,875.000000) scale(0.100000,-0.100000)" >


<path d="M3940 6292 c-190 -110 -388 -224 -440 -255 -82 -47 -95 -59 -98 -83
-3 -39 11 -57 45 -57 18 0 173 84 437 237 l409 236 393 -227 394 -227 0 -220
0 -220 -104 102 c-61 60 -111 102 -123 102 -29 0 -57 -35 -50 -62 8 -29 294
-314 325 -323 21 -6 44 14 183 151 162 161 180 189 147 222 -30 30 -61 13
-165 -90 l-103 -103 0 246 c0 222 -2 247 -17 261 -22 20 -852 500 -873 505 -8
2 -170 -86 -360 -195z"/>
<path d="M3282 5478 c-84 -84 -158 -161 -163 -171 -14 -25 -3 -52 27 -65 14
-7 28 -12 31 -12 3 0 52 46 109 102 l104 102 0 -237 c0 -231 0 -236 23 -260
12 -13 202 -128 422 -254 461 -265 439 -253 461 -253 21 0 865 486 882 508 20
26 10 64 -19 81 -25 14 -38 8 -446 -227 l-420 -242 -389 224 -389 224 -3 218
-2 218 103 -102 c57 -56 109 -102 116 -102 16 0 61 46 61 62 0 17 -322 338
-340 338 -7 0 -83 -69 -168 -152z"/>
<path d="M3212 4373 c-16 -16 -87 -95 -158 -176 l-129 -149 -3 149 c-3 178 -6
183 -107 183 -101 0 -95 28 -95 -432 0 -388 0 -395 21 -414 29 -26 129 -26
158 0 19 17 21 32 23 169 l3 150 138 -159 c77 -87 150 -167 163 -178 32 -24
63 -16 114 30 32 29 40 43 40 71 0 31 -15 50 -147 184 l-146 149 146 149 c132
133 147 152 147 183 0 25 -8 42 -32 65 -64 60 -94 66 -136 26z"/>
<path d="M4720 4381 c-34 -9 -52 -47 -46 -96 7 -60 21 -65 178 -65 l138 0 0
-329 c0 -389 -4 -375 100 -376 104 0 100 -14 100 376 l0 329 138 0 c167 0 177
4 177 79 0 90 18 86 -398 88 -199 1 -373 -2 -387 -6z"/>
<path d="M5897 4380 c-251 -5 -270 -6 -283 -24 -11 -16 -14 -89 -14 -411 0
-386 0 -392 21 -411 19 -18 42 -19 293 -22 320 -4 340 -1 356 58 12 44 5 99
-15 127 -12 16 -35 18 -235 21 l-221 3 3 62 3 62 150 3 c179 3 185 6 185 103
0 95 -8 99 -190 99 l-150 0 0 65 0 65 211 0 c120 0 218 4 229 10 36 19 49 124
20 170 -13 21 -83 25 -363 20z"/>
<path d="M6670 4367 c-172 -58 -274 -174 -303 -342 -15 -89 1 -196 42 -280 80
-163 294 -270 473 -237 77 14 184 67 212 105 l21 28 -29 55 c-17 32 -41 61
-57 69 -25 13 -31 12 -85 -16 -108 -58 -218 -49 -302 25 -48 42 -72 98 -72
171 0 142 97 238 240 239 55 0 74 -5 121 -32 31 -18 63 -32 72 -32 24 0 73 46
91 84 24 51 13 80 -45 117 -110 70 -256 88 -379 46z"/>
<path d="M744 4366 c-18 -14 -19 -30 -19 -416 0 -375 1 -402 18 -415 45 -32
156 -25 173 13 5 9 11 118 14 242 l5 225 92 -125 c96 -131 116 -150 158 -150
49 0 81 28 164 144 46 64 87 119 92 122 5 3 9 -7 9 -23 0 -172 8 -422 14 -436
10 -22 47 -32 110 -30 85 2 81 -20 84 428 3 385 2 395 -18 415 -16 16 -32 20
-77 19 -32 0 -66 -3 -75 -7 -10 -4 -79 -88 -154 -187 -75 -99 -140 -180 -144
-180 -5 0 -67 77 -140 172 -72 95 -140 179 -152 188 -29 19 -127 20 -154 1z"/>
<path d="M2118 4353 c-28 -31 -368 -729 -368 -757 0 -27 52 -73 98 -87 59 -17
83 2 132 106 l39 85 168 0 168 0 47 -94 c52 -105 67 -116 130 -95 53 17 88 52
88 86 0 37 -334 732 -366 761 -37 33 -102 31 -136 -5z m113 -395 l40 -83 -77
-3 c-42 -2 -79 -1 -81 2 -5 5 67 166 74 166 2 0 22 -37 44 -82z"/>
<path d="M3520 4360 c-19 -19 -20 -33 -20 -408 0 -328 2 -391 15 -409 17 -24
79 -38 125 -28 62 14 60 -2 60 435 l0 399 -22 15 c-34 24 -133 21 -158 -4z"/>
<path d="M3844 4359 c-18 -20 -19 -44 -22 -388 -4 -415 -1 -433 54 -451 43
-15 117 -5 136 17 10 12 14 75 18 245 l5 229 180 -240 c185 -248 198 -261 266
-261 34 0 81 17 91 33 4 7 8 191 8 409 l0 397 -22 15 c-29 20 -127 21 -154 2
-18 -13 -19 -31 -24 -253 l-5 -238 -183 247 c-100 135 -190 249 -198 252 -9 3
-42 6 -73 6 -46 0 -62 -4 -77 -21z"/>
<path d="M7230 4360 c-19 -19 -20 -33 -20 -406 0 -242 4 -392 10 -404 21 -40
132 -47 173 -12 15 13 17 35 17 169 l0 153 165 0 165 0 0 -155 0 -155 27 -17
c36 -24 126 -22 153 2 19 17 20 32 20 416 l0 398 -22 15 c-32 22 -141 22 -159
0 -10 -12 -15 -62 -19 -173 l-5 -156 -160 0 -160 0 -2 154 c-2 187 -5 191
-100 191 -50 0 -67 -4 -83 -20z"/>
<path d="M732 3328 c-17 -17 -15 -44 4 -62 14 -15 354 -16 3595 -16 2449 0
3586 3 3600 10 21 12 25 50 7 68 -17 17 -7189 17 -7206 0z"/>
<path d="M795 3058 c-57 -31 -73 -106 -32 -153 12 -14 47 -33 77 -43 59 -18
75 -43 41 -62 -21 -11 -43 -3 -93 32 -14 10 -21 9 -37 -6 -29 -26 -26 -39 14
-75 30 -26 44 -31 86 -31 55 0 103 20 119 49 5 11 10 39 10 64 0 53 -25 80
-90 97 -69 18 -88 40 -52 59 13 7 27 6 46 -5 16 -8 34 -14 42 -14 15 0 34 30
34 54 0 37 -117 61 -165 34z"/>
<path d="M1320 3055 c-9 -10 -11 -47 -9 -122 4 -92 8 -114 28 -146 60 -98 207
-92 257 11 23 46 33 234 14 257 -18 21 -57 18 -70 -4 -5 -11 -10 -63 -10 -115
0 -83 -3 -99 -20 -116 -11 -11 -31 -20 -45 -20 -14 0 -34 9 -45 20 -17 17 -20
33 -20 116 0 52 -5 104 -10 115 -13 23 -52 25 -70 4z"/>
<path d="M1962 3058 c-8 -8 -12 -59 -12 -163 0 -104 4 -155 12 -163 18 -18
172 -16 207 3 16 8 36 31 46 52 17 35 17 41 2 82 -12 33 -13 50 -5 64 17 32
-7 94 -45 117 -25 15 -50 20 -112 20 -50 0 -86 -5 -93 -12z m168 -96 c0 -11
-12 -22 -31 -29 -42 -16 -38 -55 6 -63 22 -4 31 -11 33 -29 5 -29 -12 -41 -60
-41 l-38 0 0 90 0 90 45 0 c36 0 45 -3 45 -18z"/>
<path d="M2592 3045 c-38 -32 -48 -72 -29 -118 13 -29 25 -39 71 -56 31 -12
61 -21 66 -21 17 0 11 -47 -6 -54 -25 -9 -31 -8 -63 20 -36 30 -68 25 -77 -12
-13 -49 51 -89 133 -82 67 6 102 36 109 94 7 62 -11 86 -86 110 -50 16 -66 26
-68 42 -4 27 23 33 66 13 31 -14 34 -14 55 7 17 18 19 26 11 40 -30 48 -134
58 -182 17z"/>
<path d="M3225 3052 c-46 -22 -79 -55 -94 -95 -42 -110 44 -237 160 -237 98 0
145 37 108 84 -19 25 -22 25 -49 11 -57 -30 -121 -8 -139 48 -27 82 50 147
131 111 40 -18 40 -18 60 5 22 29 20 38 -14 64 -38 28 -113 32 -163 9z"/>
<path d="M3750 3051 c-5 -11 -10 -81 -10 -156 0 -145 7 -175 43 -175 33 0 47
19 47 62 0 37 1 38 36 38 33 0 36 -3 56 -50 16 -39 26 -50 44 -50 12 0 30 7
38 15 14 14 13 21 -4 66 -18 45 -19 52 -5 79 22 43 19 102 -7 135 -30 39 -77
55 -157 55 -59 0 -72 -3 -81 -19z m174 -93 c18 -29 -4 -53 -53 -56 l-41 -3 0
41 0 41 41 -3 c27 -2 46 -9 53 -20z"/>
<path d="M4352 3062 c-9 -7 -12 -48 -10 -173 l3 -164 35 0 35 0 3 164 c3 169
0 181 -38 181 -8 0 -21 -4 -28 -8z"/>
<path d="M4772 3062 c-9 -7 -12 -48 -10 -173 l3 -164 35 0 c35 0 35 0 38 48
l3 47 45 0 c86 0 134 44 134 121 0 55 -26 94 -76 115 -36 15 -151 19 -172 6z
m152 -88 c19 -7 21 -45 4 -62 -7 -7 -29 -12 -50 -12 -38 0 -38 0 -38 40 0 39
1 40 34 40 19 0 41 -3 50 -6z"/>
<path d="M5344 3056 c-15 -38 0 -51 59 -54 l57 -3 0 -120 c0 -130 8 -159 43
-159 42 0 47 17 47 152 l0 127 58 3 c56 3 57 3 57 33 l0 30 -158 3 c-131 2
-158 0 -163 -12z"/>
<path d="M6006 3054 c-13 -13 -16 -41 -16 -155 0 -149 7 -179 43 -179 43 0 47
15 47 175 0 155 -5 175 -41 175 -10 0 -25 -7 -33 -16z"/>
<path d="M6504 3054 c-18 -9 -42 -26 -54 -39 -23 -24 -52 -115 -45 -138 2 -7
6 -24 9 -39 3 -14 18 -40 32 -58 76 -89 214 -83 273 13 92 150 -62 337 -215
261z m125 -90 c26 -22 31 -33 31 -70 0 -89 -90 -128 -144 -63 -54 64 -16 155
66 158 9 1 30 -11 47 -25z"/>
<path d="M7086 3054 c-13 -13 -16 -42 -16 -163 0 -155 4 -171 46 -171 34 0 43
20 46 107 l3 80 70 -91 c72 -92 100 -111 131 -86 11 10 14 44 14 166 0 144 -1
154 -20 164 -28 15 -59 4 -65 -23 -3 -12 -6 -53 -7 -91 l-3 -70 -63 87 c-78
107 -103 124 -136 91z"/>
<path d="M7743 3035 c-32 -32 -35 -40 -30 -77 7 -52 23 -68 95 -93 60 -22 75
-47 40 -68 -13 -9 -25 -5 -57 17 -43 30 -63 29 -81 -3 -8 -17 -5 -26 18 -52
25 -28 37 -33 88 -36 75 -5 118 18 134 75 10 31 9 45 -3 74 -14 33 -22 39 -74
54 -63 17 -89 36 -79 53 9 14 63 14 71 1 16 -25 75 8 75 42 0 20 -67 48 -113
48 -43 0 -54 -5 -84 -35z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
